<button
  #trigger
  type="button"
  class="top-bar-dropdown top-bar-dropdown--date"
  [class.top-bar-dropdown--open]="customOpen()"
  [matMenuTriggerFor]="dateMenu"
  data-test="date-range-menu-trigger">
  <mat-icon class="top-bar-dropdown-icon">date_range</mat-icon>
  <span class="top-bar-dropdown-label">
    @if (customLabel(); as label) {
      {{ label }}
    } @else {
      {{ presetLabelKey() | translate }}
    }
  </span>
  <mat-icon class="top-bar-dropdown-arrow">arrow_drop_down</mat-icon>
</button>
<mat-menu #dateMenu="matMenu" class="top-bar-menu">
  @for (option of options(); track option.preset) {
    <button mat-menu-item (click)="selectPreset(option.preset)">
      <span>{{ option.labelKey | translate }}</span>
    </button>
  }
  <button mat-menu-item (click)="openCustomRange()">
    @if (customActive()) {
      <mat-icon class="top-bar-menu-check">check</mat-icon>
    }
    <span>{{ "dateRange.customRange" | translate }}</span>
  </button>
</mat-menu>

<ng-template #customRangeTemplate>
  <div class="custom-range-panel" data-test="date-range-menu-custom-range">
    <app-date-range-picker
      [initialStartDate]="customStart()"
      [initialEndDate]="customEnd()"
      (startDate)="onCustomStart($event)"
      (endDate)="onCustomEnd($event)"></app-date-range-picker>
  </div>
</ng-template>
